import WebEnquiryTypes from "./webEnquiry.types";

// Fetch Actions
export const webEnquiryFetchStart = (webEnquiryData: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_FETCH_START,
  payload: webEnquiryData,
});

export const webEnquiryFetchSuccess = (success: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_FETCH_SUCCESS,
  payload: success,
});

export const webEnquiryFetchFailure = (failure: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_FETCH_FAILURE,
  payload: failure,
});

export const webEnquiryFetchResetStart = () => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_FETCH_RESET_START,
});

export const webEnquiryFetchResponseChanged = () => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_FETCH_RESPONSE_CHANGED,
});

// Export Actions
export const webEnquiryExportStart = (exportData: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_EXPORT_START,
  payload: exportData,
});

export const webEnquiryExportSuccess = (success: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_EXPORT_SUCCESS,
  payload: success,
});

export const webEnquiryExportFailure = (failure: any) => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_EXPORT_FAILURE,
  payload: failure,
});

export const webEnquiryExportResetStart = () => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_EXPORT_RESET_START,
});

export const webEnquiryExportChanged = () => ({
  type: WebEnquiryTypes.WEB_ENQUIRY_EXPORT_CHANGED,
});
